module.exports = __webpack_public_path__ + "img/bj3.bc0b73dd.png";